import { KeyloopSubitemsModal, SubitemsModal } from "components/InterventionSubitemsModal/components";
import "components/InterventionSubitemsModal/InterventionSubitemsModal.scss";
import { isKeyLoopLocation } from "utils/common";

import type { DealerLocation, InterventionElement } from "models";

type InterventionSubitemsModalProps = {
  isLoading?: boolean;
  location?: DealerLocation | null;
  element?: InterventionElement | null;
  onSubmit: (element: InterventionElement) => void;
  onClose?: () => void;
};

export const InterventionSubitemsModal = ({ onClose, onSubmit, element, isLoading, location }: InterventionSubitemsModalProps) => {
  if (isKeyLoopLocation(location))
    return <KeyloopSubitemsModal onClose={onClose} onSubmit={onSubmit} element={element} location={location ?? undefined} isLoading={isLoading} />;
  return <SubitemsModal onClose={onClose} onSubmit={onSubmit} element={element} isLoading={isLoading} />;
};
